module.exports = __webpack_public_path__ + "img/z.89508b54.svg";